import React from 'react';
import { useNavigate } from 'react-router-dom';

import { IChat } from '@sv-support-sdk/shared-types/src/common/chats';
import List from '@sv-support-sdk/ui-components/src/components/Lists/List';

import HistoryPanel from '../../../components/Panels/HistoryPanel';

import { routes } from '../../../routing';
import Smile from '../../../components/Feedback/Smile';

interface Props {
  chats: IChat[];
}

const ChatHistoryCards = ({ chats }: Props) => {
  const navigate = useNavigate();

  return (
    <List gap="16" className="indent-md-top">
      {chats.map((chat) => {
        const score = chat.score || chat.rate;

        return (
          <HistoryPanel
            key={chat.id}
            date={chat.closedAt}
            withNoticeDot={false}
            title={String(chat.id)}
            description={chat.firstMessage?.message || ''}
            onClick={() => navigate(`${routes.chats}/${chat.id}`)}
          >
            <Smile score={score} />
          </HistoryPanel>
        );
      })}
    </List>
  );
};

export default ChatHistoryCards;
